import React from 'react';
import moment from 'moment';

export default function RodapeEmissor({ numeroInfracao }) {
    return (
        <div className="print m-2 d-flex align-items-center justify-content-between">
            <p>Auto de Infração e Sanção: {numeroInfracao}</p>
            <p>documento original extraído do sistema FiscSP, em {moment().format("DD/MM/YYYY")}</p>
        </div>
    );
}
